<template>
  <div class="form-item mb24">
    <button class="mt12 btn btn_billing-address" @click="$emit('openBillingModal')">
      <span>
        <svg
          width="16"
          height="22"
          viewBox="0 0 16 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.83749 0.999939C6.53228 0.999939 5.29585 1.29467 4.1912 1.82119C-1.41466 4.4932 1.33993 12.1818 5.02375 17.1813L7.83749 20.9999L10.6512 17.1813C14.3351 12.1818 17.0896 4.4932 11.4838 1.82119C10.3792 1.29467 9.14271 0.999939 7.83749 0.999939Z"
            stroke="#9BCD82"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.70094 9.63629H4.20094"
            stroke="#9BCD82"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.70094 7.63629H4.20094"
            stroke="#9BCD82"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.201 4.76231C9.88143 4.68005 9.54633 4.63629 9.20103 4.63629C6.99188 4.63629 5.20103 6.42715 5.20103 8.63629C5.20103 10.8454 6.99188 12.6363 9.20103 12.6363C9.54633 12.6363 9.88143 12.5925 10.201 12.5103"
            stroke="#9BCD82"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
      <span class="ml20">{{ billingAddress }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "app-billing-address",
  props: {
    billingAdddressString: {
      required: false
    }
  },
  computed: {
    billingAddress() {
      return this.billingAdddressString
        ? this.billingAdddressString
        : this.$t("forms.billingAddress");
    }
  }
};
</script>